/**
 * @type {Function}
 * @param {string} filename The name of the file to download
 * @param {Array<Array<string|number>>} data The 2D array of data to export
 * @returns {void}
 * @throws {Error} If data is not a non-empty 2D array
 */
export const exportToCsv = (filename = 'data', data = []) => {
    if (!Array.isArray(data) || !data.length) {
        throw new Error('Please provide data to export.');
    }

    if (!data.every(row => Array.isArray(row))) {
        throw new Error('Data must be a 2D array.');
    }

    const csvContent = data.map(row => row.join(',')).join('\n');

    // --- iOS
    if (window.webkit?.messageHandlers?.exportFile) {
        window.webkit.messageHandlers.exportFile.postMessage({
            filename: `${filename}.csv`,
            contents: csvContent,
        });
        return;
    }

    // --- Android
    if (window.android?.exportFile) {
        window.android.exportFile(
            JSON.stringify({
                filename: `${filename}.csv`,
                contents: csvContent,
            })
        );
        return;
    }

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
